import { Injectable } from '@angular/core';

export enum EExternalApplicationName {
  watabi = 'watabi',
}

export interface IExternalApplication {
    application: string,
    bookingIdItem: number;
    bookingIdVersion: number;
    blockIdItem: number;
    location: string;
    begin: string;
    xtoken: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExternalApplicationService {
  private externalApplication: IExternalApplication = null;
  constructor() { 
    const externalApplication = sessionStorage.getItem('IQBA_ExternalApplicationData');
    if (externalApplication) {
      this.externalApplication = JSON.parse(externalApplication);
    }
  }

  public getExternalApplicationName(): string | null {
    return this.externalApplication?.application ?? null;
  }

  public getExternalApplicationLocation(): string | null {
    return this.externalApplication?.location ?? null;
  }
}
